export default "/_next/static/media/image-8-563x1024.3f2a08eafe801cf3f7139551ecd9a086.png";